<app-drawer
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
  (keydown.escape)="onEscape()"
  [title]="drawerTitle()"
  [config]="drawerConfig()"
  [size]="DrawerSize.FULL"
  [zIndex]="zIndex()"
  (closeDrawer)="close()">
  <div drawer-body class="flex h-full min-h-0 flex-col gap-1 text-sm">
    <app-toolbox
      [searchConfig]="toolboxSearchConfig()"
      [showPageSelector]="true"
      [paginationConfig]="toolboxPagination()"
      (pageChange)="onPageChange($event)"
      [(searchQuery)]="searchQuery"
      (advancedQuerySearch)="onAdvancedQuerySearch($event)"
      [useAdvancedFiltering]="true"
      [(showAdvancedFiltering)]="showAdvancedFiltering"
      [openFilterForField]="openFilterForField()"
      [showCustomContent]="activeGrammar() === 'path'"
      class="text-text-primary shrink-0">
      @if (activeGrammar() === 'path' && pathBar.vocabulary(); as vocab) {
        <app-path-filter-search-bar
          class="min-w-80 flex-1"
          [vocabulary]="vocab"
          [state]="pathBar.bar()"
          (stateChange)="pathBar.editBar($event)" />
      }
    </app-toolbox>

    @if (
      activeGrammar() === 'path' && showAdvancedFiltering() && pathBar.vocabulary();
      as vocab
    ) {
      <app-path-filter-pills
        class="border-weak bg-elevated block shrink-0 border-b"
        [vocabulary]="vocab"
        [draft]="pathBar.draft()"
        [invalidPaths]="pathBar.invalidPaths()"
        (draftChange)="pathBar.editDraft($event)"
        (openAdvanced)="pathBar.pathPanel.set('filter')">
        <app-path-filter-sort
          [vocabulary]="vocab"
          [sort]="pathBar.sort()"
          (sortChange)="pathBar.editSort($event)" />
        <app-filter-presets filter-presets />
      </app-path-filter-pills>
    } @else if (showAdvancedFiltering()) {
      <app-filter-query-builder
        class="shrink-0"
        [availableFields]="availableAdvancedFilters()"
        [initialConfiguration]="advancedFilters()"
        [openFilterForField]="openFilterForField()"
        (filterChange)="onFilterChanges($event)">
        <app-filter-presets filter-presets />
      </app-filter-query-builder>
    }

    <div class="flex min-h-0 flex-1">
      <app-table
        #appTable
        [allColumns]="columns()"
        [data]="tableData()"
        [tableId]="`entity-picker-${entityType().toLowerCase()}`"
        [config]="tableConfig()"
        [initialSort]="presetSort()"
        [selected]="selectedEntities()"
        (sortChange)="onSortChange($event)"
        (addFilterOn)="addFilterOn($event)"
        (removeFilterOn)="removeFilterOn($event)"
        (listItemClick)="onListItemClick($event)"
        class="min-h-0 min-w-0 flex-1">
      </app-table>
      @if (
        activeGrammar() === 'path' && pathBar.pathPanel() && pathBar.vocabulary();
        as vocab
      ) {
        <app-path-filter-panel
          appFocusFirst
          appReturnFocus
          class="h-full shrink-0"
          [title]="'features.data.path_filter.panel.title' | translate"
          [entityType]="entityType().toUpperCase()"
          [count]="totalEntities()"
          [error]="pathBar.error()"
          (closed)="pathBar.pathPanel.set(null)">
          <app-path-filter-composer
            panel-body
            [vocabulary]="vocab"
            [draft]="pathBar.draft()"
            [invalidPaths]="pathBar.invalidPaths()"
            (draftChange)="pathBar.editDraft($event)" />
          <div panel-footer class="flex flex-1 items-center gap-2">
            <i [class]="ICONS.checkCircle"></i>
            <span>{{ 'features.data.path_filter.panel.applied' | translate }}</span>
            <span class="flex-1"></span>
            <app-path-filter-move-buttons />
            <button type="button" class="btn-cancel btn-sm" (click)="pathBar.clearByHand()">
              {{ 'common.clear' | translate }}
            </button>
          </div>
        </app-path-filter-panel>
      }
    </div>
  </div>

  <span drawer-footer class="text-text-tertiary text-sm">{{ shownLabel() }}</span>
</app-drawer>

<app-dropdown-singleton
  #localDropdown
  class="fixed top-0 left-0"
  [style.z-index]="dropdownZIndex()" />
